import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const enModules = import.meta.glob<{ default: Record<string, unknown> }>(
  './locales/en/*.json',
  { eager: true },
);
const frModules = import.meta.glob<{ default: Record<string, unknown> }>(
  './locales/fr/*.json',
  { eager: true },
);

const merge = (modules: Record<string, { default: Record<string, unknown> }>) =>
  Object.values(modules).reduce<Record<string, unknown>>(
    (acc, mod) => ({ ...acc, ...mod.default }),
    {},
  );

const enResources = merge(enModules);
const frResources = merge(frModules);

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: enResources },
        fr: { translation: frResources },
      },
      fallbackLng: 'en',
      supportedLngs: ['en', 'fr'],
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'vendor_lang',
        caches: ['localStorage'],
      },
    });
} else {
  i18n.addResourceBundle('en', 'translation', enResources, true, true);
  i18n.addResourceBundle('fr', 'translation', frResources, true, true);
}

if (import.meta.hot) {
  import.meta.hot.accept();
}

export default i18n;
